// import { GetPastConferencesDataType } from '@/api/conference';
import { Newsletter } from '@/api/notice';

export interface ColumnDef {
	key: string;
	title: string;
}

// 각 타입에 맞는 Key 매핑
const COLUMN_MAP = {
	title: ['newsletter_title'],
	hit: ['newsletter_hit'],
	enrollment_date: ['newsletter_enrollment_date'],
	admin: ['admin_name'],
};

// 타입별 동적 컬럼 생성 함수
export const generateColumns = (data: (Newsletter)[]): ColumnDef[] => {
	if (data.length === 0) return [];

	// 현재 데이터 배열에서 사용 가능한 key 확인
	const sample = data[0];

	// 사용 가능한 key를 동적으로 선택
	const getAvailableKey = (keys: string[]) => keys.find((key) => key in sample) || '';

	return [
		{ key: 'no', title: 'NO.' },
		{ key: getAvailableKey(COLUMN_MAP.title), title: '제목' },
		{ key: getAvailableKey(COLUMN_MAP.enrollment_date), title: '등록일' },
		{ key: getAvailableKey(COLUMN_MAP.hit), title: '조회수' },
	].filter((col) => col.key); // key가 없는 경우 제거
};
